<template>
    <div style="float: right; position: relative; width: 300px;overflow: initial;" class="research-query">
        <el-input v-model="search" placeholder="搜索文献"
                  prefix-icon="el-icon-search"
                  style="position: absolute; right: 0; top: -12px; padding: 0;">
            <el-button slot="append" @click="jump()">搜索</el-button>
        </el-input>
    </div>
</template>

<script>
export default {
    name: "ResearchQuery",
    props:["query"],
    data() {
        return {
            search: '',
        }
    },
    created() {
        //load search from localstorage
        // this.search = localStorage.getItem('article-search') || ''

        this.search = this.$route.query.q
    },
    watch:{
        '$route': 'Clear'
    },
    methods: {
        jump() {
            //save search to localstorage
            localStorage.setItem('article-search', this.search)
            // 判断当前要搜索的内容是否为当前已搜索出来的内容
            if (this.$route.query.q!=this.search || this.$route.query.cat!=this.query.cat || this.$route.query.subCat!=this.query.subCat) {
                if (this.$router.currentRoute.path.includes('research')){
                    if(this.query == undefined){
                        this.$router.push({
                            path: '/research',
                            query: {
                                page: 0,
                                q: this.search,
                            }
                        })
                    }else if (this.query.subCat == undefined) {
                        this.$router.push({
                            path: '/research',
                            query: {
                                page: 0,
                                q: this.search,
                                cat:this.query.cat
                            }
                        })
                    } else {
                        this.$router.push({
                            path: '/research',
                            query: {
                                page: 0,
                                q: this.search,
                                subCat:this.query.subCat
                            }
                        })
                    }
                }
                else if (this.$router.currentRoute.path.includes('article')){
                    var newsurl='/articleList/2?type=2&page=0&sort=date&order=1&q='+this.search +'&topic=';
                    if(this.$router.currentRoute.path.includes('articleList')&&this.query.topic!='显示全部'){
                        newsurl = newsurl + this.query.topic
                    }
                    this.$router.push(newsurl);
                }
            } else {
                this.$message({
                    message: '搜索结果已显示，请勿重复搜索',
                    // type: 'success' //绿色弹窗
                    type: 'warning' //黄色弹窗
                });
            }
        },
        // 切换菜单时将输入框内数据清空
        Clear(){
            // 判断路由发生变化时为菜单变化还是搜索时产生的变化
            if (this.$route.query.q !='') {
                // 实现用户输入文字的回显
                this.search=this.$route.query.q
            } else {
                // 清空输入框
                this.search=''
            }
        }
    },
}
</script>

<style scoped>

</style>

<style>
.research-query *, .research-query input::placeholder {
    color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/ResearchQuery.vue